/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  SYS_PAGE_MARGIN,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_RELATIVE_2_XL,
} from '@oneaudi/unified-web-common';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import styled, { css } from 'styled-components';

export const StyledBanner = styled.div<{
  alignment?: string;
  fullWidth: boolean;
  imgAlignment: string;
  hasAnyImage: boolean;
  bannerLayout: string;
}>`
  background-color: ${(props: any) =>
    props.theme.sys?.color.canvas[100] || props.theme.sys?.color.canvas.default};
  display: flex;
  flex-direction: ${({ imgAlignment }) => (imgAlignment === 'left' ? 'row' : 'row-reverse')};
  justify-self: ${(props) => (props.alignment ? props.alignment : 'center')};
  height: 100%;
  ${(props) => props.fullWidth && 'justify-content: space-between;'}
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    max-height: ${({ hasAnyImage }) => (hasAnyImage ? '100px' : '122px')};
    ${(props) => props.fullWidth && props.bannerLayout && 'max-height: 120px;'}
  }
  @media (min-width: 768px) {
    ${(props) => !props.fullWidth && 'max-width: 970px;'}
  }
`;

export const StyledPicture = styled.picture<{ bannerLayout: string; fullWidth: boolean }>`
  display: flex;

  ${({ bannerLayout }) =>
    bannerLayout !== 'imageOnly' &&
    `
      height: auto;
      width: 120px;
      `}

  @media ((min-width: 768px) and (max-width: 1023px)) {
    ${({ bannerLayout }) =>
      bannerLayout !== 'imageOnly' &&
      `
         width: 200px;
      `}
  }
  @media (min-width: 1024px) {
    ${({ bannerLayout }) =>
      bannerLayout !== 'imageOnly' &&
      `
         width: 300px;
      `}
  }

  /* IMAGE ONLY AND NOT FULL WIDTH */

  ${({ bannerLayout, fullWidth }) =>
    bannerLayout === 'imageOnly' &&
    css`
      ${fullWidth && 'width: 100%;'}

      @media (max-width: 374px) {
        ${!fullWidth && 'aspect-ratio: 320/50;'}
      }

      @media (min-width: 375px) and (max-width: 767px) {
        ${!fullWidth && 'aspect-ratio: 728/90;'}
      }

      @media (min-width: 768px) {
        ${!fullWidth && 'aspect-ratio: 970/90;'}
      }

      @media (min-width: 1024px) {
        ${fullWidth && 'max-height: 120px;'}
      }
    `}
`;

export const StyledImage = styled.img<{ fullWidth: boolean; bannerLayout: string }>`
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${({ fullWidth }) =>
    fullWidth &&
    `
    object-fit: unset;
  `}

  ${({ bannerLayout }) =>
    bannerLayout !== 'imageOnly' &&
    `
    width: 120px;
    height: 100%;
    object-fit: cover;
  `}

  @media ((min-width: 768px) and (max-width: 1023px)) {
    ${({ bannerLayout }) =>
      bannerLayout !== 'imageOnly' &&
      `
      width: 200px;
      `}
  }
  @media (min-width: 1024px) {
    ${({ bannerLayout }) =>
      bannerLayout !== 'imageOnly' &&
      `
      width: 300px;
      `}
  }
`;

export const TextLayout = styled.div<{
  bannerLayout: string;
  imgAlignment: string;
  hasAnyImage: boolean;
  hasText: boolean;
}>`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  /* padding: ${SYS_SPACE_FIXED_100} ${SYS_PAGE_MARGIN} ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_150}; */
  padding: ${({ imgAlignment }) =>
    imgAlignment === 'left'
      ? `${SYS_SPACE_FIXED_100} ${SYS_PAGE_MARGIN} ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_150}`
      : `${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_100} ${SYS_PAGE_MARGIN}`};

  ${({ bannerLayout }) =>
    bannerLayout === 'textOnly' &&
    ` padding-right: ${SYS_PAGE_MARGIN};
      padding-left: ${SYS_PAGE_MARGIN};
      `}
  width: 100%;
  justify-content: center;

  @media ((min-width: 768px) and (max-width: 1023px)) {
    flex-direction: ${({ hasAnyImage }) => (hasAnyImage ? 'column' : 'row')};

    padding: ${({ imgAlignment }) =>
      imgAlignment === 'left'
        ? `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_150}`
        : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN}`};

    ${({ bannerLayout }) =>
      bannerLayout === 'textOnly' &&
      ` padding-right: ${SYS_PAGE_MARGIN};
      padding-left: ${SYS_PAGE_MARGIN};
      `}
  }
  @media (min-width: 1024px) {
    align-items: center;
    flex-direction: row;
    gap: ${SYS_SPACE_FIXED_150};
    justify-content: space-between;
    padding: ${({ imgAlignment }) =>
      imgAlignment === 'left'
        ? `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_RELATIVE_2_XL}`
        : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_RELATIVE_2_XL} ${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN}`};

    ${({ bannerLayout }) =>
      bannerLayout === 'textOnly' &&
      ` padding-right: ${SYS_PAGE_MARGIN};
      padding-left: ${SYS_PAGE_MARGIN};
      `}
  }

  .banner-headline {
    @media ((min-width: 320px) and (max-width: 767px)) {
      font-size: var(--Sys-FontSizes-Relative-75, 12px);
      font-style: normal;
      font-weight: 700;
      line-height: var(--Sys-LineHeights-Relative-LH125, 20px);
      letter-spacing: var(--Sys-LetterSpacing-None, 0);
      font-stretch: 105%;
    }
  }
  a {
    flex: 0 0 auto;
    align-items: end;
  }
`;

export const CustomTextLink = styled(TextLink)`
  font-size: var(--font-size-Copy-2, 12px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--font-line-height-Copy-2, 20px);
  letter-spacing: 0.002px;
  text-decoration: none;
  min-height: 22px;
  padding-bottom: 0;
  width: max-content;

  @media (min-width: 1024px) {
    align-self: flex-end;
  }
`;

export const CustomText = styled(Text)`
  @media ((min-width: 320px) and (max-width: 1023px)) {
    margin-bottom: ${SYS_SPACE_FIXED_150};
  }
`;

export const TextWrapper = styled.div<{ textAlignment: string; bannerLayout: string }>`
  text-align: ${({ textAlignment }) => textAlignment};
  width: 100%;

  ${({ bannerLayout }) =>
    bannerLayout === 'imageAndText' &&
    `
    height: 100%;
    align-content: center;
  `}
`;

export const SVG = styled.svg`
  margin-bottom: ${SYS_SPACE_FIXED_100};
  display: grid;
  justify-self: flex-end;
`;

export const CtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  @media (min-width: 1024px) {
    align-self: flex-end;
  }
`;
